Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  none: 'none',
  URL: 'URL',
  addressCity: 'addressCity',
  addressCityAndState: 'addressCityAndState',
  addressState: 'addressState',
  countryName: 'countryName',
  creditCardNumber: 'creditCardNumber',
  emailAddress: 'emailAddress',
  familyName: 'familyName',
  fullStreetAddress: 'fullStreetAddress',
  givenName: 'givenName',
  jobTitle: 'jobTitle',
  location: 'location',
  middleName: 'middleName',
  name: 'name',
  namePrefix: 'namePrefix',
  nameSuffix: 'nameSuffix',
  nickname: 'nickname',
  organizationName: 'organizationName',
  postalCode: 'postalCode',
  streetAddressLine1: 'streetAddressLine1',
  streetAddressLine2: 'streetAddressLine2',
  sublocality: 'sublocality',
  telephoneNumber: 'telephoneNumber',
  username: 'username',
  password: 'password',
  newPassword: 'newPassword',
  oneTimeCode: 'oneTimeCode'
};